export default {
    language: "Bahasa Indonesia",
    StripeSuccess: {
        loading: "Memproses pembayaran Anda...",
        successMessage: "Langganan Anda telah berhasil diaktifkan!",
        processingError: "Pemrosesan pembayaran gagal, silakan hubungi kami",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "Email",
            createdAt: "Dibuat pada",
            noRecord: "Tidak ada catatan",
            loginTime: "Waktu login",
        },
        orders: {
            title: "Riwayat pesanan",
            loading: "Memuat...",
            refresh: "Segarkan",
            orderAmount: "Jumlah",
            points: "Poin",
            createdAt: "Dibuat pada",
            orderType: "Tipe",
            status: "Status",
            noOrders: "Tidak ada pesanan",
            goToSubscription: "Beli poin",
            freeCredit: "Kredit gratis",
            paidCredit: "Kredit berbayar",
            queryOrderFailed: "Gagal menanyakan pesanan",
            statusPaid: "Dibayar",
            statusPending: "Tertunda",
            statusCancelled: "Dibatalkan",
            statusDeactivated: "Dinonaktifkan",
            checkoutUrlNotAvailable: "Gagal mendapatkan URL pembayaran",
            verifyingPayment: "Memverifikasi status pembayaran...",
            paymentSuccess: "Pembayaran berhasil",
            paymentPending: "Pesanan menunggu pembayaran, silakan selesaikan pembayaran",
            paymentFailed: "Pembayaran gagal atau dibatalkan",
            paymentStatus: "Status pembayaran",
            paymentStatusDescription: "Apakah Anda telah menyelesaikan pembayaran?",
            cancelPayment: "Batalkan pembayaran",
            completedPayment: "Pembayaran selesai",
            warning: "Peringatan",
            confirmCancelOrder: "Apakah Anda yakin ingin membatalkan pesanan ini? Tindakan ini tidak dapat dibatalkan.",
            cancel: "Batal",
            confirm: "Konfirmasi",
            cancellingOrder: "Membatalkan pesanan...",
            orderCancelledSuccess: "Pesanan dibatalkan",
            cancelOrderFailed: "Gagal membatalkan pesanan",
            checkOrderStatusFailed: "Gagal memeriksa status pesanan",
            promptClick: "Klik status \"Tertunda\" untuk melanjutkan pembayaran",
        }
    },
    UserFeedback: {
        title: "Testimoni Pengguna",
        feedback: "Dengarkan ulasan nyata dari kreator dan profesional di seluruh dunia tentang teknologi pemrosesan gambar AI kami.",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "Tuan Lin",
                profession: "Editor Video & Kreator Konten",
                rating: 5,
                comment: "Luar biasa! ClixMagicAI sangat cepat! Unggah video dengan watermark, dalam beberapa menit Anda akan mendapatkan versi tanpa watermark, tanpa kehilangan kualitas sama sekali. Alat penghapus watermark yang wajib dimiliki!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "Nyonya Su",
                profession: "Spesialis Pemasaran Media Sosial",
                rating: 5,
                comment: "ClixMagicAI telah menyelamatkan perpustakaan konten Instagram saya! Watermark kompleks juga dapat dikenali dengan tepat, pemrosesan tepi jauh lebih halus dibandingkan perangkat lunak lain, dan hasilnya terlihat lebih alami."
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "Tuan Chen",
                profession: "Produser Konten Video Pendek",
                rating: 5,
                comment: "Menghapus watermark dengan ClixMagicAI sangat mudah, proses konten TikTok selama perjalanan, kemudian unduh versi HD segera setelah tiba di kantor! Ini adalah berkah bagi para profesional media."
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "Tuan Huang",
                profession: "Desainer Grafis & Direktur Kreatif Visual",
                rating: 5,
                comment: "Sebagai desainer, saya sangat puas! Ketika menangani gambar dengan logo yang disediakan klien, tekstur latar belakang dipulihkan secara alami, tanpa bekas Photoshop, menghemat waktu pasca-pemrosesan."
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "Nyonya Emily",
                profession: "Kreator Konten Digital Freelance",
                rating: 5,
                comment: "Temuan yang luar biasa! Harga keanggotaan jauh lebih terjangkau dibandingkan produk penghapus watermark lainnya, tetapi efek penghapusan watermark sebenarnya lebih baik, terutama dengan watermark transparan gradien."
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "Tuan Robertson",
                profession: "Pengembang Kursus Pelatihan Korporat",
                rating: 5,
                comment: "ClixMagicAI tidak perlu diinstal, yang sangat nyaman! Komputer perusahaan tidak mengizinkan instalasi perangkat lunak, tetapi sekarang kami dapat memproses materi kursus menggunakan browser saja, di mana saja dan kapan saja."
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "Nyonya Zhou",
                profession: "Ibu Rumah Tangga & Editor Media Komunitas",
                rating: 5,
                comment: "Antarmukanya begitu sederhana sehingga nenek saya pun bisa menggunakannya! Jika Anda tidak punya waktu untuk mempelajari perangkat lunak profesional seperti Photoshop, cobalah ClixMagicAI - ini sempurna untuk pemula teknologi seperti saya! Haha~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "Tuan Johnson",
                profession: "Strategis Visual E-commerce",
                rating: 5,
                comment: "ClixMagicAI sangat kuat, dapat menghapus gambar, video, objek kecil, orang, dan teks. Fiturnya komprehensif, saya merekomendasikannya kepada semua orang~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "Nyonya Fang",
                profession: "Penggemar Fotografi & Pembagi Konten Online",
                rating: 5,
                comment: "Wow~ Akhirnya saya menemukan alat penghapus watermark yang tidak merusak kualitas gambar! Ini ajaib~ Pengeditan foto sekarang bukan masalah lagi! Sangat direkomendasikan!!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "Tuan Williams",
                profession: "Instruktur Pendidikan Online",
                rating: 5,
                comment: "Fitur memori posisi watermark sangat berguna! Saat memproses video kursus serial, saya tidak perlu memilih berulang kali, menghemat setidaknya setengah jam waktu kerja dan sangat meningkatkan efisiensi persiapan pengajaran saya."
            }
        ]
    },
    Order: {
        purchasePoints: "Beli Poin",
        subtitle: "Pilih paket poin yang sesuai untuk menikmati layanan penghapusan watermark berkualitas tinggi",
        loginReminderDesc: "Login untuk memilih dan membeli poin",
        freeTag: "Gratis",
        freePlan: "Paket Gratis",
        autoActivated: "Otomatis aktif setelah login",
        points: "Poin",
        autoIncluded: "Hadiah gratis",
        discount: "Diskon",
        purchase: "Beli Sekarang",
        paymentStatusDescription: "Apakah Anda sudah menyelesaikan pembayaran?",
        paymentNotCompleted: "Pembayaran belum selesai",
        queryOrderFailed: "Gagal memeriksa status pesanan",
        cancelPayment: "Batalkan Pembayaran",
        completedPayment: "Pembayaran Selesai",
        warning: "Peringatan",
        confirmCancelOrder: "Apakah Anda yakin ingin membatalkan pesanan ini? Tindakan ini tidak dapat dibatalkan.",
        cancel: "Batal",
        confirm: "Konfirmasi",
        selectProductFirst: "Silakan pilih paket terlebih dahulu",
        creatingOrder: "Membuat pesanan...",
        orderCreated: "Pesanan berhasil dibuat",
        createOrderFailed: "Gagal membuat pesanan",
        checkoutUrlNotAvailable: "Gagal mendapatkan link pembayaran",
        cancellingOrder: "Membatalkan pesanan...",
        orderCancelledSuccess: "Pesanan telah dibatalkan",
        cancelOrderFailed: "Gagal membatalkan pesanan",
        verifyingPayment: "Memeriksa status pembayaran...",
        paymentSuccess: "Pembayaran berhasil",
        paymentPending: "Pesanan menunggu pembayaran, silakan selesaikan pembayaran",
        paymentFailed: "Pembayaran gagal atau dibatalkan",
        checkOrderStatusFailed: "Gagal memeriksa status pesanan",
        quickStart: "Mulai Cepat",
        shortTerm: "Penggunaan Jangka Pendek",
        recommended: "Direkomendasikan",
        bestValue: "Nilai Terbaik",
    },
    Login: {
        title: "Login",
        subtitle: "Login cepat dengan akun sosial",
        memberTip: "Login untuk menikmati lebih banyak fitur",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "Login dengan akun GitHub"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "Login dengan akun Google"
            }
        ],
        error: {
            serverError: "Kesalahan server, silakan coba lagi nanti",
            networkError: "Kesalahan jaringan, silakan periksa koneksi Anda"
        }
    },
    OAuthCallback: {
        loading: "Memproses permintaan login",
        pleaseWait: "Harap tunggu, sedang memverifikasi informasi login...",
        error: "Login gagal",
        backToHome: "Kembali ke Beranda",
        success: "Login berhasil",
        redirecting: "Mengalihkan ke halaman utama..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "Harga",
            faq: "Pertanyaan umum",
        },
        login: "Login",
        userMenu: {
            account: "Akun",
            logout: "Logout",
            credit: "Poin",
            freeCredit: "Gratis",
            paidCredit: "Dibeli",
            nextUpdate: "Pembaruan poin berikutnya",
            language: "Bahasa",
            theme: "Tema",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    ProductAdv: {
        title: "Fitur ClixMagicAI",
        advs: [
            {
                title: "Mesin Pengenalan AI: Deteksi Otomatis Elemen Pengganggu",
                desc: "Berbasis algoritma pembelajaran mendalam, secara otomatis mengenali watermark, teks, wajah, dan elemen latar belakang kompleks dalam gambar/video, tanpa perlu penandaan manual. Mendukung format dari Instagram, TikTok, dan platform lainnya, dengan perlindungan data privasi yang ketat.",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "Hapus Watermark"
            },
            {
                title: "Ahli Pembersihan Gambar: Hapus Logo/Stempel Tanggal dengan Cepat, Kualitas Terjaga",
                desc: "Menghapus dengan tepat watermark merek, tanggal pengambilan, stiker, dan elemen pengganggu lainnya. AI secara otomatis memperbaiki tekstur latar belakang, gambar setelah diproses tampak alami seperti aslinya, sempurna untuk postingan media sosial.",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "Hapus Watermark"
            },
            {
                title: "Penghapus Watermark Dinamis: Hapus Subtitle Bergerak/Logo Platform",
                desc: "Hapus dengan satu klik kartu akhir YouTube, watermark TikTok, dan teks bergulir. AI melacak dan memproses setiap frame, menghasilkan video 4K berkualitas tinggi yang mulus, mendukung format MP4/MOV dan format populer lainnya.",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "Hapus Watermark"
            }
        ]
    },
    Description:{
        title: "ClixMagicAI",
        desc: "Alat penghapus watermark profesional berbasis AI yang dapat dengan cepat menghapus watermark dari gambar, video, dan PDF dengan mudah, memberikan hasil yang alami.",
        fileTypes: {
            image: 'Hapus Watermark Gambar',
            pdf: 'Hapus Watermark PDF',
            video: 'Hapus Watermark Video'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "Uji Coba Gratis Harian", icon: "fa-gift" },
            { id: "imageTag", text: "Penghapusan Watermark Gambar", icon: "fa-image" },
            { id: "videoTag", text: "Penghapusan Watermark Video", icon: "fa-video" },
            { id: "aiPoweredTag", text: "Didukung AI", icon: "fa-robot" },
            { id: "noRegTag", text: "Login & Gunakan", icon: "fa-user-check" },
        ],
        videoPromt: "Segera Hadir!",
        videoDesc: "Kami sedang mengembangkan fitur penghapusan watermark video yang akan memberikan pengalaman lebih baik."
    },
    Footer: {
        social: {
            title: "Hubungi Kami",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:support@clixmagic.com",
                    text: "support@clixmagic.com"
                },
            ]
        },
        termsTitle: "Ketentuan Hukum",
        terms: [
            {
                id: 1,
                title: "Kebijakan Privasi",
                link: "/privacy"
            },
            {
                id: 2,
                title: "Ketentuan Layanan",
                link: "/terms"
            },
            {
                id: 3,
                title: "Kebijakan Cookie",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI Hak Cipta Dilindungi."
    },
    Task: {
        image: {
            imageSupportText: 'Mendukung format jpg, jpeg, png, webp, heic, heif, maksimal 10MB per file',
            imageFileTooLarge: 'Ukuran file melebihi batas (maks 10MB)',
            invalidImageType: 'Format gambar tidak didukung, harap unggah JPG, JPEG, PNG, WEBP, HEIC, atau HEIF',
            imageWillCost: 'Akan menggunakan: 1 poin',
            hiecSupportText: 'Format HEIC/HEIF akan otomatis dikonversi ke PNG saat dikirim',
            hiecSuccess: 'Format HEIC/HEIF berhasil dikonversi',
            hiecFailed: 'Konversi format HEIC/HEIF gagal',
            processingImageTip: 'Memproses gambar Anda, harap tunggu...',
            guide: {
                title: 'Panduan Penggunaan',
                step1: 'Unggah gambar',
                step2: 'Sapukan pada area watermark atau biarkan model mendeteksi watermark secara otomatis',
                step3: 'Klik kirim'
            }
        },
        common: {
            remaining: 'Poin tersisa',
            nextUpdate: 'Pembaruan poin berikutnya',
            handleError: 'Kesalahan saat memproses file, silakan coba file lain',
            uploadFailed: 'Pengunggahan file gagal',
            dragText: 'Tarik file ke sini atau',
            clickText: 'klik untuk mengunggah',
            loginRequired: 'Silakan login terlebih dahulu untuk mengunggah file',
            noRemainingTasks: 'Semua poin Anda telah habis',
            loginNow: 'Login Sekarang',
            upgradeNow: 'Beli Poin Sekarang',
            taskSubmitSuccess: 'Tugas berhasil dikirim',
            taskSubmitError: 'Pengiriman tugas gagal',
            taskRetrySuccess: 'Percobaan ulang tugas berhasil dikirim!',
            taskRetryError: 'Percobaan ulang tugas gagal dikirim!',
            processing: 'Memproses',
            submit: 'Kirim',
            waiting: 'Menunggu',
            completed: 'Selesai',
            failed: 'Gagal',
            cancelled: 'Dibatalkan',
            url_not_found: 'Gagal mendapatkan link',
            deleted: 'Dihapus',
            refreshSuccess: 'Daftar tugas telah disegarkan',
            refreshFailed: 'Gagal menyegarkan daftar tugas',
            deleteSuccess: 'Tugas berhasil dihapus',
            deleteFailed: 'Gagal menghapus tugas',
            waitingForCompletion: 'Harap tunggu tugas saat ini selesai sebelum mencoba lagi',
            loadOriginalImageFailed: 'Gagal memuat gambar asli, silakan coba lagi',
            downloadFailed: 'Unduhan gagal',
            startingDownload: 'Memulai unduhan...',
            noTasks: 'Tidak ada tugas',
            refresh: 'Segarkan',
            sort: 'Urutkan',
            noFilterTasks: 'Tidak ada tugas {filter}',
            compare: 'Lihat perbandingan',
            originalImage: 'Gambar asli',
            processedImage: 'Gambar diproses',
            dragToCompare: '👈 Geser kiri-kanan untuk membandingkan 👉',
            cancel: "Batal",
            delete: "Hapus",
            retry: "Coba lagi",
            download: "Unduh",
            createAt: "Dibuat pada",
            expiredAt: "Kedaluwarsa pada",
        },
        video: {
            videoSupportText: 'Mendukung format mp4, mov, avi, mkv, maksimal 100MB per file',
            videoFileTooLarge: 'Ukuran file melebihi batas (maks 100MB)',
            invalidVideoType: 'Format video tidak didukung, harap unggah MP4, MOV, AVI, atau MKV',
            videoWillCost: 'Akan menggunakan: 3 poin',
            processingVideoTip: 'Memproses video Anda, harap tunggu...',
            guide: {
                step1: 'Unggah video',
                step2: 'Pilih jenis watermark dan tentukan area watermark',
                step3: 'Klik kirim'
            },
            annotationTools: 'Alat Anotasi Watermark',
            selectType: 'Pilih Jenis Watermark',
            deleteAnnotation: 'Hapus Anotasi',
            clearAllAnnotations: 'Hapus Semua Anotasi',
            annotationHelp: 'Bantuan Anotasi',
            dragTip: 'Tarik untuk menggambar area watermark',
            resizeTip: 'Sesuaikan ukuran dengan watermark',
            moveTip: 'Anotasi yang dibuat dapat dipindahkan',
            processing: 'Memproses',
            submit: 'Kirim',
            taskSubmitSuccess: 'Tugas berhasil dikirim',
            taskSubmitError: 'Pengiriman tugas gagal',
            retryTaskTip: 'Percobaan ulang tugas berhasil dikirim',
            retryFailed: 'Percobaan ulang tugas gagal',
            uploadFailed: 'Pengunggahan gagal',
            staticWatermarkDesc: 'Cocok untuk watermark statis dengan posisi tetap',
            normalWatermarkDesc: 'Cocok untuk watermark normal yang tetap',
            dynamicWatermarkDesc: 'Cocok untuk watermark dinamis yang berubah',
            moveWatermarkDesc: 'Cocok untuk watermark yang perlu dipindahkan'
        },
    },
    Router: {
        home: "Beranda",
        terms: "Ketentuan Layanan",
        privacy: "Kebijakan Privasi",
        cookie: "Kebijakan Cookie",
        user: "Pusat Pengguna",
    },
    FAQ: {
        title: "Panduan Penggunaan dan Pertanyaan Umum ClixMagicAI",
        prompt: "Mengalami masalah atau punya pertanyaan? Hubungi kami kapan saja: support@clixmagic.com",
        questions: [
            {
                id : 1,
                question: "Apa itu ClixMagicAI dan bagaimana cara kerjanya?",
                answer: "ClixMagicAI adalah alat penghapus watermark berbasis AI canggih. Alat ini dapat mengenali watermark secara otomatis pada gambar dan video, serta menyediakan fitur penandaan posisi watermark secara manual. Untuk gambar, alat ini mendukung berbagai format konversi dan menjamin output berkualitas tinggi; untuk video, dapat menangani watermark statis, dinamis, bahkan yang berubah bentuk."
            },
            {
                id : 2,
                question: "Apakah ClixMagicAI menawarkan penggunaan gratis?",
                answer: "Ya, kami menyediakan layanan dasar gratis 3 poin setiap hari! Anda dapat menggunakannya untuk memproses gambar (menggunakan 1 poin per operasi) atau video (menggunakan 3 poin per operasi). Selain itu, Anda juga dapat membeli poin tambahan yang berlaku selamanya."
            },
            {
                id : 3,
                question: "Bisakah saya membeli poin tambahan?",
                answer: "Tentu saja! Selain 3 poin gratis yang diberikan setiap hari, Anda dapat memperoleh poin tambahan melalui opsi pembelian kami. Semua poin yang dibeli akan berlaku secara permanen, tanpa tanggal kedaluwarsa."
            },
            {
                id : 4,
                question: "Format file apa saja yang didukung?",
                answer: "Untuk gambar, kami mendukung format PNG, JPEG, JPG, WEBP, HEIC dan HEIF, dengan HEIC dan HEIF akan otomatis dikonversi ke PNG. Untuk video, kami mendukung berbagai format termasuk MP4 dan MOV."
            },
            {
                id : 5,
                question: "Bagaimana privasi saya dilindungi?",
                answer: "Di ClixMagicAI, kami sangat menghargai privasi pengguna. Semua file yang diunggah akan dienkripsi dan dihapus secara otomatis dalam 24 jam setelah pemrosesan selesai. Kami tidak menyimpan file pengguna atau informasi terkait."
            },
            {
                id : 6,
                question: "Bagaimana cara login ke ClixMagicAI?",
                answer: "Kami mendukung login cepat melalui akun GitHub atau Google, memastikan keamanan akun Anda sekaligus menyederhanakan proses pendaftaran."
            },
            {
                id : 7,
                question: "Seberapa cepat pemrosesannya?",
                answer: "Berkat server performa tinggi dan algoritma AI yang dioptimalkan, sebagian besar tugas penghapusan watermark gambar dapat diselesaikan dalam 10 detik, sementara penghapusan watermark video secepat 1 menit. Waktu sebenarnya dapat bervariasi tergantung ukuran file dan kompleksitasnya."
            },
            {
                id : 8,
                question: "Bagaimana hasil setelah pemrosesan?",
                answer: "Model AI kami telah dilatih secara ekstensif, dapat menghapus watermark dari gambar dan video secara cerdas sekaligus mempertahankan kualitas konten asli. Baik watermark yang dikenali secara otomatis maupun yang ditandai secara manual dapat dihapus secara efektif, memastikan hasil akhir terlihat alami tanpa bekas."
            },
            {
                id : 9,
                question: "Berapa lama masa berlaku setiap tugas?",
                answer: "Setelah tugas selesai, file yang telah diproses akan disimpan di ClixMagicAI selama 24 jam untuk diunduh pengguna. Setelah kedaluwarsa, file akan dihapus secara otomatis dari server kami untuk melindungi privasi Anda."
            },
            {
                id : 10,
                question: "Berapa batas ukuran file maksimum?",
                answer: "Kami menerima ukuran file gambar maksimum 10MB dan file video maksimum 100MB. File yang melebihi batas ini mungkin perlu dikompresi atau dipotong terlebih dahulu sebelum diunggah."
            }
        ]
    },
    Terms: {
        "tabs": {
            "terms": "Ketentuan Layanan",
            "privacy": "Kebijakan Privasi",
            "cookies": "Kebijakan Cookie"
        },
        "lastUpdated": "Pembaruan terakhir: 20 Mei 2025",
        "terms": {
            "sections": [
                {
                    "title": "1. Pendahuluan",
                    "description": "Selamat datang di ClixMagicAI. Penggunaan layanan kami berarti Anda menerima ketentuan layanan ini. Harap baca dengan seksama."
                },
                {
                    "title": "2. Deskripsi Layanan",
                    "description": "ClixMagicAI menyediakan alat berbasis AI untuk menghapus watermark dari gambar, video, dan file PDF. Layanan kami ditujukan untuk penggunaan sah berikut:",
                    "items": [
                        "Menghapus watermark dari konten Anda sendiri",
                        "Menghapus watermark dari konten yang Anda memiliki hak modifikasi yang sesuai",
                        "Untuk tujuan pendidikan dan penelitian"
                    ]
                },
                {
                    "title": "3. Tanggung Jawab Pengguna",
                    "description": "Dengan menggunakan ClixMagicAI, Anda setuju untuk:",
                    "items": [
                        "Hanya mengunggah konten yang Anda miliki atau memiliki hak modifikasi yang sesuai",
                        "Tidak menggunakan layanan kami untuk tujuan ilegal atau melanggar hukum apa pun",
                        "Tidak mencoba menghindari langkah-langkah keamanan atau pembatasan penggunaan kami",
                        "Tidak menggunakan layanan kami untuk melanggar hak kekayaan intelektual pihak lain"
                    ]
                },
                {
                    "title": "4. Ketentuan Akun",
                    "description": "Anda mungkin perlu membuat akun untuk menggunakan beberapa fitur layanan kami. Untuk masuk, Anda dapat memilih untuk menggunakan akun Google atau GitHub. Anda bertanggung jawab untuk:",
                    "items": [
                        "Menjaga keamanan akun Anda",
                        "Semua aktivitas yang terjadi di bawah akun Anda",
                        "Memberikan informasi akun yang akurat (termasuk tetapi tidak terbatas pada avatar, email, nama pengguna, dan ID pengguna)"
                    ]
                },
                {
                    "title": "5. Layanan Gratis dan Berbayar",
                    "description": "ClixMagicAI menawarkan kuota dasar gratis dan opsi pembelian poin yang fleksibel untuk mengakses fitur penghapusan watermark kami:",
                    "items": [
                        "Kuota dasar: Setiap pengguna akan secara otomatis menerima 3 poin gratis setiap hari, yang dapat digunakan untuk pemrosesan konten",
                        "Aturan penggunaan poin: Penghapusan watermark gambar menggunakan 1 poin per operasi, penghapusan watermark video menggunakan 3 poin per operasi",
                        "Pembelian poin: Anda dapat memilih untuk membeli paket poin untuk penggunaan lebih banyak, semua poin yang dibeli berlaku secara permanen, tanpa batasan kedaluwarsa",
                        "Kebijakan pengembalian dana: Karena sifat instan dan virtual layanan digital, poin tidak dapat dikembalikan setelah berhasil dibeli"
                    ]
                },
                {
                    "title": "6. Hak Kekayaan Intelektual",
                    "description": "Layanan ClixMagicAI, termasuk semua perangkat lunak, desain, dan konten yang kami buat, adalah kekayaan intelektual kami. Anda tidak boleh menyalin, memodifikasi, atau membuat karya turunan berdasarkan layanan kami tanpa izin."
                },
                {
                    "title": "7. Batasan Tanggung Jawab",
                    "description": "ClixMagicAI menyediakan layanan \"sebagaimana adanya\", tanpa jaminan jenis apa pun. Kami tidak bertanggung jawab atas kerusakan apa pun yang timbul dari penggunaan layanan kami."
                },
                {
                    "title": "8. Perubahan Ketentuan",
                    "description": "Kami dapat memodifikasi ketentuan ini kapan saja. Penggunaan ClixMagicAI yang berkelanjutan setelah perubahan ketentuan berarti Anda menerima ketentuan yang dimodifikasi."
                },
                {
                    "title": "9. Penghentian",
                    "description": "Kami berhak untuk mengakhiri atau menangguhkan akses Anda ke layanan kami segera, tanpa pemberitahuan sebelumnya, jika kami percaya bahwa perilaku Anda melanggar ketentuan ini atau membahayakan pengguna lain, diri kami sendiri, atau pihak ketiga."
                },
                {
                    "title": "10. Hukum yang Berlaku",
                    "description": "Ketentuan ini akan diatur oleh hukum yang berlaku di tempat pendaftaran perusahaan kami, terlepas dari ketentuan konflik hukum."
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. Pendahuluan",
                    "description": "Di ClixMagicAI, kami menghargai privasi Anda dan berkomitmen untuk melindungi data pribadi Anda. Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi Anda saat Anda menggunakan situs web dan layanan kami. Dengan mengakses situs web kami atau menggunakan layanan kami, Anda menerima praktik pemrosesan data yang dijelaskan dalam kebijakan ini. Kami mematuhi peraturan perlindungan data yang berlaku."
                },
                {
                    "title": "2. Informasi yang Kami Kumpulkan",
                    "description": "Kami mungkin mengumpulkan jenis informasi berikut:",
                    "items": [
                        { "bold": "Informasi akun", "text": "Avatar pengguna, alamat email, nama pengguna, dan ID pengguna yang diberikan saat masuk melalui Google atau GitHub" },
                        { "bold": "Data penggunaan", "text": "Informasi tentang bagaimana Anda menggunakan layanan kami, termasuk fitur yang diakses dan waktu penggunaan" },
                        { "bold": "Konten yang diunggah", "text": "Gambar, video, atau file PDF yang Anda unggah untuk pemrosesan" },
                        { "bold": "Informasi pembayaran", "text": "Informasi pembayaran saat membeli langganan (diproses dengan aman oleh gateway pembayaran pihak ketiga seperti Creem/Stripe/PayPal, kami hanya menyimpan catatan status pembayaran)" },
                        { "bold": "Data teknis", "text": "Alamat IP, jenis browser, informasi perangkat" }
                    ]
                },
                {
                    "title": "3. Bagaimana Kami Menggunakan Informasi Anda",
                    "description": "Kami menggunakan informasi Anda untuk:",
                    "items": [
                        { "text": "Menyediakan, memelihara, dan meningkatkan layanan kami" },
                        { "text": "Memproses dan menyelesaikan transaksi" },
                        { "text": "Mengirim pemberitahuan teknis dan pesan dukungan" },
                        { "text": "Menanggapi komentar dan pertanyaan Anda" },
                        { "text": "Menganalisis pola penggunaan untuk meningkatkan pengalaman pengguna, dan memproses data pribadi hanya sejauh yang diperlukan untuk mencapai tujuan layanan" },
                        { "text": "Memastikan periode penyimpanan data pribadi tidak melebihi waktu yang diperlukan" },
                        { "text": "Mencegah penipuan atau aktivitas ilegal" }
                    ]
                },
                {
                    "title": "4. Keamanan Data",
                    "description": "Kami menerapkan langkah-langkah keamanan yang sesuai dengan standar industri untuk melindungi informasi pribadi Anda:",
                    "items": [
                        { "text": "Enkripsi AES-256 untuk file selama transmisi dan penyimpanan" },
                        { "text": "Pemrosesan data sensitif menggunakan arsitektur pengetahuan nol" },
                        { "text": "Audit log keamanan harian dan pemindaian kerentanan" },
                        { "text": "Akses staf mengikuti prinsip hak istimewa minimum" }
                    ]
                },
                {
                    "title": "5. Berbagi Data",
                    "description": "Kami tidak menjual informasi pribadi Anda. Kami mungkin berbagi informasi dengan:",
                    "items": [
                        { "bold": "Penyedia layanan", "text": "Terbatas pada pemrosesan data yang diperlukan untuk menyediakan layanan tertentu (seperti penyimpanan cloud CloundFlare, gateway pembayaran pihak ketiga seperti Creem/Stripe/PayPal), yang harus menandatangani perjanjian pemrosesan data" },
                        { "bold": "Persyaratan hukum", "text": "Ketika kami menerima panggilan pengadilan yang valid, perintah pengadilan, atau proses hukum lainnya yang berlaku bagi kami" }
                    ]
                },
                {
                    "title": "6. Hak Anda",
                    "description": "Sesuai dengan hukum yang berlaku di wilayah Anda, Anda mungkin memiliki hak-hak berikut:",
                    "items": [
                        { "text": "Mengakses salinan data pribadi Anda" },
                        { "text": "Memperbaiki informasi yang tidak akurat atau tidak lengkap" },
                        { "text": "Hak untuk penghapusan data ('hak untuk dilupakan'), kecuali kami memiliki alasan hukum untuk menyimpannya" },
                        { "text": "Menolak atau membatasi jenis pemrosesan data tertentu" },
                        { "text": "Hak terhadap portabilitas data, Anda dapat meminta transfer data Anda" }
                    ]
                },
                {
                    "title": "7. Privasi Anak-anak",
                    "description": "Layanan kami tidak ditujukan untuk mereka yang berusia di bawah 16 tahun. Sesuai dengan Pasal 8 Peraturan Perlindungan Data Umum (GDPR), persetujuan untuk anak di bawah 16 tahun harus diberikan oleh orang tua atau wali. Jika Anda mengetahui bahwa anak di bawah 16 tahun telah memberikan kami informasi pribadi, harap segera hubungi kami di support@clixmagic.com."
                },
                {
                    "title": "8. Perubahan pada Kebijakan Ini",
                    "description": "Kami mungkin memperbarui Kebijakan Privasi ini dari waktu ke waktu. Kami akan memberi tahu Anda tentang perubahan signifikan dengan memposting kebijakan baru di halaman ini dan memperbarui tanggal 'pembaruan terakhir'. Untuk perubahan penting, kami akan memberi tahu pengguna melalui email atau cara menonjol lainnya."
                },
                {
                    "title": "9. Hubungi Kami",
                    "description": "Jika Anda memiliki pertanyaan tentang Kebijakan Privasi ini, silakan hubungi kami di support@clixmagic.com. Jika Anda percaya data Anda telah diproses dengan cara yang tidak pantas atau memiliki kekhawatiran, jangan ragu untuk menghubungi kami kapan saja."
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. Apa itu Cookie",
                    "description": "Cookie adalah file teks kecil yang ditempatkan di komputer atau perangkat seluler Anda saat Anda mengunjungi situs web. Mereka memungkinkan situs web mengenali perangkat Anda dan mengingat apakah Anda telah mengunjungi situs sebelumnya."
                },
                {
                    "title": "2. Bagaimana Kami Menggunakan Cookie",
                    "description": "ClixMagicAI menggunakan cookie untuk berbagai tujuan:",
                    "items": [
                        { "bold": "Cookie yang diperlukan", "text": "Diperlukan untuk fungsi dasar situs web kami (seperti manajemen sesi dan fitur keamanan)" },
                        { "bold": "Cookie preferensi", "text": "Mengingat pengaturan dan preferensi Anda untuk meningkatkan pengalaman Anda, misalnya, mengingat avatar, nama pengguna, dll. Anda setelah masuk melalui Google atau GitHub" },
                        { "bold": "Cookie analitik", "text": "Membantu kami memahami bagaimana pengunjung berinteraksi dengan situs web kami dengan mengumpulkan informasi anonim" },
                        { "bold": "Cookie pemasaran", "text": "Melacak kebiasaan browsing Anda untuk menawarkan iklan yang relevan dengan minat Anda" }
                    ]
                },
                {
                    "title": "3. Jenis Cookie yang Kami Gunakan",
                    "subsection": [
                        {
                            "title": "3.1 Cookie yang Diperlukan",
                            "description": "Cookie ini penting untuk fungsi situs web yang tepat. Mereka memungkinkan fungsi inti seperti keamanan, manajemen jaringan, dan akses akun (termasuk login melalui Google dan GitHub). Anda dapat mengonfigurasi browser Anda untuk memblokir cookie ini, tetapi beberapa bagian situs web mungkin tidak berfungsi dengan baik."
                        },
                        {
                            "title": "3.2 Cookie Kinerja dan Analitik",
                            "description": "Cookie ini membantu kami memahami bagaimana pengunjung berinteraksi dengan situs web kami dengan mengumpulkan informasi anonim. Kami menggunakan data ini untuk meningkatkan situs web dan layanan kami. Cookie ini tidak mengumpulkan informasi yang dapat mengidentifikasi pengunjung."
                        },
                        {
                            "title": "3.3 Cookie Fungsionalitas",
                            "description": "Cookie ini memungkinkan situs web kami mengingat pilihan yang Anda buat (seperti preferensi bahasa atau status login) untuk memberikan fungsi yang ditingkatkan, dipersonalisasi, seperti mengingat status login Anda melalui Google atau GitHub."
                        },
                        {
                            "title": "3.4 Cookie Penargetan dan Periklanan",
                            "description": "Cookie ini digunakan untuk menampilkan iklan yang relevan kepada pengunjung dan melacak efektivitas kampanye iklan kami. Perhatikan bahwa karena situs web kami terutama bergantung pada login pihak ketiga (Google dan GitHub), jenis cookie ini terutama digunakan untuk meningkatkan pengalaman pengguna dan bukan untuk pemasaran langsung."
                        }
                    ]
                },
                {
                    "title": "4. Pengelolaan Cookie",
                    "description": "Anda dapat mengontrol dan mengelola cookie dengan berbagai cara. Sebagian besar browser web memungkinkan pengelolaan preferensi cookie. Anda dapat:",
                    "items": [
                        { "text": "Menghapus cookie dari perangkat Anda" },
                        { "text": "Memblokir cookie dengan mengaktifkan pengaturan browser Anda yang memungkinkan Anda menolak beberapa atau semua cookie" },
                        { "text": "Mengatur browser Anda untuk memberi tahu Anda ketika Anda menerima cookie" }
                    ]
                },
                {
                    "title": "5. Cookie Pihak Ketiga",
                    "description": "Beberapa cookie ditempatkan oleh pihak ketiga di situs web kami. Pihak ketiga ini mungkin termasuk layanan analitik (seperti Google Analytics) dan jaringan periklanan. Karena cara kerja cookie (cookie hanya dapat diakses oleh pihak yang awalnya menetapkannya), kami tidak mengontrol penggunaan cookie pihak ketiga ini dan tidak dapat mengaksesnya. Untuk pengguna yang masuk melalui Google dan GitHub, kami akan memastikan bahwa pedoman privasi platform ini diikuti saat menangani informasi terkait."
                },
                {
                    "title": "6. Memperbarui Kebijakan Cookie Ini",
                    "description": "Kami mungkin memperbarui Kebijakan Cookie ini dari waktu ke waktu untuk mencerminkan perubahan dalam teknologi, peraturan, atau praktik bisnis kami. Setiap perubahan akan diposting di halaman ini dan tanggal revisi akan diperbarui."
                },
                {
                    "title": "7. Hubungi Kami",
                    "description": "Jika Anda memiliki pertanyaan tentang penggunaan cookie kami, silakan hubungi kami di support@clixmagic.com."
                }
            ]
        }
    },
}